module.exports = __webpack_public_path__ + "img/package_sowfeeder.5df5eb8f.svg";